<fieldset [disabled]="isDisabled">
  <div class="input-group mb-3">
    <button class="btn btn-light border" type="button" (click)="decrease()">
      -
    </button>
    <span *ngIf="prefixLabel" class="input-group-text">{{ prefixLabel }}</span>
    <input
      type="number"
      class="form-control"
      [(ngModel)]="value"
      (blur)="onBlur()"
      hluSelectOnFocus
    />
    <span *ngIf="suffixLabel" class="input-group-text">{{ suffixLabel }}</span>
    <button class="btn btn-light border" type="button" (click)="increase()">
      +
    </button>
  </div>
</fieldset>
